var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { Icon, useCopyToClipboard, useLang } from '@shapeable/ui';
import { CopyIcon } from '../icons/copy-icon';
import { classNames } from '@shapeable/utils';
import { ChevronUpIconGlyph } from '@shapeable/icons';
var cls = classNames('gpt-output-button');
export var GptOutputButtonDefaultProps = {
  variant: 'copy'
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var IconAndLabelStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    color: ", ";\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    cursor: pointer;\n    \n    &:hover {\n      ", ";\n      color: ", ";\n    }\n  "], ["\n    color: ", ";\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    cursor: pointer;\n    \n    &:hover {\n      ", ";\n      color: ", ";\n    }\n  "])), theme.COLOR('text'), theme.FILL('primary'), theme.COLOR('primary'))
});
var LabelStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    color: inherit;\n    font-size: ", ";\n    font-weight: 500;\n  "], ["\n    color: inherit;\n    font-size: ", ";\n    font-weight: 500;\n  "])), theme.FONT_SIZE(12))
});
var IconStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  "], ["\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  IconAndLabel: styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), IconAndLabelStyles),
  Label: styled.span(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  Icon: styled(Icon)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), IconStyles)
};
export var GptOutputButton = function (props) {
  var className = props.className,
    children = props.children,
    variant = props.variant,
    onClick = props.onClick,
    gptText = props.gptText;
  var t = useLang();
  var _a = __read(useCopyToClipboard(gptText), 2),
    copied = _a[0],
    copy = _a[1];
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, variant === 'copy' ? React.createElement(My.IconAndLabel, {
    onClick: function () {
      copy();
    }
  }, React.createElement(My.Icon, {
    color: 'text',
    size: 18
  }, React.createElement(CopyIcon, null)), React.createElement(My.Label, null, copied ? 'Copied!' : children)) : React.createElement(My.IconAndLabel, {
    onClick: onClick
  }, React.createElement(My.Icon, {
    color: 'text',
    size: 16
  }, React.createElement(ChevronUpIconGlyph, null)), React.createElement(My.Label, null, children)));
};
GptOutputButton.cls = cls;
GptOutputButton.defaultProps = GptOutputButtonDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;